module.exports = __webpack_public_path__ + "img/fn-1.50e31e6.svg";